import { createAction } from 'redux-actions'

export const REDUCER_NAME = "flashMessage";

// Action Creator
const SET_SUCCESS = 'FLASH_MESSAGE/SET_SUCCESS';
export const setSuccess = createAction(SET_SUCCESS)
const SET_UNSUCCESS = 'FLASH_MESSAGE/SET_UNSUCCESS';
export const setUnSuccess = createAction(SET_UNSUCCESS)
const SET_OPEN = 'FLASH_MESSAGE/SET_OPEN';
export const setOpen = createAction(SET_OPEN)
const SET_CLOSE = 'FLASH_MESSAGE/SET_CLOSE';
export const setClose = createAction(SET_CLOSE)

// Selector
export const getSuccess = state => state;
export const getOpen = state => state;

export const INITIAL_STATE = {
  isSuccess: false,
  isOpen: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_SUCCESS':
      return { ...state, isSuccess: true };
    case 'SET_UNSUCCESS':
      return { ...state, isSuccess: false };
    case 'SET_OPEN':
      return { ...state, isOpen: true };
    case 'SET_CLOSE':
      return { ...state, isOpen: false };
    default:
      return state;
  }
};
